import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-16" data-mp="4lyim45afqa5" />);
}